var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"סוג תכנית","items":_vm.planTypes},model:{value:(_vm.plan),callback:function ($$v) {_vm.plan=$$v},expression:"plan"}})}
var staticRenderFns = []

export { render, staticRenderFns }